module.exports = __webpack_public_path__ + "img/what-we-sell_0005.6e5cfa86.jpg";